/**
 * @typedef {import('./index.js').Store<State, Getters>} Store
 */
import $ from 'jquery'
import Cookies from 'js-cookie'
import {logger} from '@plugins/logger'
import {getApiUrl} from '@utils/api-helpers'
/**
 * @module Store:Consent
 * @description
 * Tracks the OneTrust consent modal, so every time the user changes it's consent
 * it check if one of the consent groups have beeing changed and updates our endpoint in RH
 * to set Sitecore especific functionality.
 * [Guide]{@link /docs/consentandtracking}
 */
// Consent group that needs to be tracked
const GroupToCheck = window.CookieConsentGroup ? window.CookieConsentGroup : 'C0002'
// API endpoint
const APIEndPoint = getApiUrl('/api/v1/tracking/')
/**
 * Transform querystring into object
 * @example
 * const querystring = '?text=text&label=label'
 * console.log(pareseParams(querystring))
 * // { text: 'text', label: 'label' }
 * @param {string} querystring 
 * @returns {Object}
 */
const parseParams = (querystring) => {
  if (!querystring) {
    return {}
  }
  // parse query string
  const params = new URLSearchParams(querystring)
  const obj = {};
  // iterate over all keys
  for (const key of params.keys()) {
    if (key === 'groups') {
      let groups = params.get(key).split(',')
      const groupsObj = {}
      groups.forEach((group) => {
        const gId = group.split(':')[0]
        const gValue = group.split(':')[1] === '0' ? false : true
        groupsObj[gId] = gValue
      })
      obj[key] = groupsObj
    } else if (params.getAll(key).length > 1) {
      obj[key] = params.getAll(key)
    } else {
      obj[key] = params.get(key)
    }
  }
  return obj;
}
/**
 * Update user tracking concent
 * @param {boolean} accept 
 */
const sendApiRequest = (accept) => {
  const endpointSufix = accept ? 'giveConsent' : 'revokeConsent'
  $.ajax(APIEndPoint + endpointSufix, {
    type: 'POST',
    success: (res) => {
      logger.debug(res)
    },
    error: (res) => {
      logger.debug(res)
    },
    complete: (res) => {
      logger.debug(res)
    }
  })
}
/**
 * Hanle user acceptance
 */
const handleAccept = () => {
  sendApiRequest(true)
}
/**
 * Hanle user revoke
 */
const handleRevoke = () => {
  sendApiRequest(false)
}
export default {
  namespaced: true,
  /** Consent State
   * @typedef {Object} State
   * @property {Object} payload - OptanonConsent cookies parsed
   */
  /** @type {State} */
  state: {
    payload: parseParams(Cookies.get('OptanonConsent'))
  },
  getters: {},
  // Mutations
  mutations: {
    UPDATE_COOKIE( /** @type {State} */
      state, cookieString) {
      logger.debug('ConsentGroup: ', GroupToCheck)
      const hasAccepted = state.payload.groups && state.payload.groups[GroupToCheck]
      if (!state.payload.groups) {
        state.payload = parseParams(Cookies.get('OptanonConsent'))
      }
      Object.keys(state.payload.groups).forEach((key) => {
        state.payload.groups[key] = cookieString.includes(key)
        if (key === GroupToCheck) {
          if (hasAccepted && !state.payload.groups[key]) {
            handleRevoke()
          } else if (! hasAccepted && state.payload.groups[key]) {
            handleAccept()
          }
        }
      })
      logger.debug(state.payload.groups)
    }
  },
  actions: {}
}
/**
 * Vuex plugin that listen to consent changes and update
 * user consent tracking.
 * @param {Store} store 
 */
export const ConsentPlugin = (store) => {
  let count = 0
  const interval = setInterval(() => {
    if (window.OneTrust) {
      const OneTrust = window.OneTrust
      OneTrust.OnConsentChanged((res) => {
        store.commit('consent/UPDATE_COOKIE', res.detail)
      })
      $('a.consent-manager').on('click', (e) => {
        e.preventDefault()
        OneTrust.ToggleInfoDisplay()
      })
      clearInterval(interval)
    } else if (count === 10) {
      clearInterval(interval)
    } else {
      count++
    }
  }, 1000)
}
